import errorMessages from "utils/validation/errorMessages";
import { optionalPasswordSchema, phoneRequiredSchema, stringOptionalSchema, stringRequiredSchema } from "utils/validation/validationHelpers";
import { object } from 'yup';

const profileSchema = object().shape({
    firstname: stringRequiredSchema,
    lastname: stringRequiredSchema,
    username: stringRequiredSchema,
    phone: phoneRequiredSchema,
    password: optionalPasswordSchema,
    self_description: stringOptionalSchema,
    profile_picture: stringOptionalSchema.url(errorMessages.url),
	email_signature: stringOptionalSchema,
	signature_img: stringOptionalSchema.url(errorMessages.url),
});

export default profileSchema;